import clsx from 'clsx';
import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  /** Icon element (e.g. `<Inbox />`). */
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Call to action (button/link). */
  action?: ReactNode;
  /** Smaller padding for use inside cards / tables. */
  compact?: boolean;
  className?: string;
}

/** Placeholder for empty lists, missing data and error states. */
export function EmptyState({
  icon,
  title,
  description,
  action,
  compact = false,
  className,
}: EmptyStateProps) {
  return (
    <div className={clsx(styles.empty, compact && styles.compact, className)}>
      {icon && (
        <div className={styles.icon} aria-hidden>
          {icon}
        </div>
      )}
      <p className={styles.title}>{title}</p>
      {description !== undefined && <div className={styles.description}>{description}</div>}
      {action !== undefined && <div className={styles.action}>{action}</div>}
    </div>
  );
}
